import React from "react";
import {
  ContainerIframe,
  ContainerReports,
} from "./ReportsPolicyInsightContainer.styled";

const ReportsPolicyInsightContainer = () => {
  const iframe =
    '<iframe title="Policy Insight" src="https://app.powerbi.com/reportEmbed?reportId=ee7c847c-1564-4a9f-b259-6651d507b426&autoAuth=true&ctid=638fcbaf-ba4c-43e1-adae-5475c970fe10" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>';

  return (
    <ContainerReports>
      <ContainerIframe
        contentEditable="true"
        dangerouslySetInnerHTML={{ __html: iframe }}
      ></ContainerIframe>
    </ContainerReports>
  );
};
export default ReportsPolicyInsightContainer;
